import { getCurrentInstance } from '@vue/composition-api';

export function useRouter() {
  const vm = (getCurrentInstance() as any).proxy;

  const router = vm.$router;
  const $route = vm.$route;

  const getRouterTarget = (): string | string[] | null => {
    if (router.currentRoute.query?.target) {
      return router.currentRoute.query.target;
    } else {
      return null;
    }
  };

  const extractCommunitySlugFromTarget = () => {
    const target = getRouterTarget();
    if (!target) return null;

    const parts = (() => {
      if (typeof target === 'string') return target.slice(1).split('/');
      return target;
    })();

    if (parts[0].startsWith('communities') || parts[0].startsWith('auth')) {
      return null;
    }
    return parts[0];
  };

  const gotoTargetOrCommunities = () => {
    if (router.currentRoute.query?.target) {
      router.push({ path: router.currentRoute.query.target });
    } else {
      router.push({ name: 'Communities' });
    }
  };

  return {
    router,
    $route,
    gotoTargetOrCommunities,
    extractCommunitySlugFromTarget,
    getRouterTarget,
  };
}
